import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildFilterUrl = (endpoint) => `${API_ROUTES.FILTERS.BASE}/${endpoint ? endpoint : ""}`

const defaultTours = {
  max_stopovers: -1,
  type_filter: "airbus",
  is_transfer: 0,
  period_type: "fix",
  format: "json",
}

export const filtersService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTerminals: builder.query({
      query: ({ ids, isLocal, local }) => {
        const params = new URLSearchParams()
        params.append("local", local)

        if (ids && Array.isArray(ids)) {
          ids.forEach((id) => {
            params.append("depart_terminal_ids[]", id)
          })
        }

        if (isLocal !== undefined) {
          params.append("depart_terminal_local", isLocal)
        }

        return {
          url: `${buildFilterUrl("get_arrival_terminals")}?${params.toString()}`,
          method: "GET",
        }
      },
    }),
    getFlightDates: builder.mutation({
      query: ({ departTerminalIds = [], arrivalTerminalIds = [], locale }) => {
        const body = { locale }

        if (departTerminalIds.length > 0) {
          body.depart_terminal_ids = departTerminalIds
        }
        if (arrivalTerminalIds.length > 0) {
          body.arrival_terminal_ids = arrivalTerminalIds
        }

        return {
          url: buildFilterUrl("get_flight_dates"),
          method: "POST",
          body,
        }
      },
    }),
    getFligthTransportTours: builder.mutation({
      query: (params) => {
        const allParams = { ...defaultTours, ...params }

        const formData = new URLSearchParams()

        Object.entries(allParams).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              formData.append(`tours[${key}][]`, item)
            })
          } else {
            formData.append(`tours[${key}]`, value)
          }
        })

        // if (allParams.locale) {
        //   formData.append("locale", allParams.locale)
        // }

        return {
          url: buildFilterUrl("transport_tours"),
          method: "POST",
          body: formData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      },
    }),
    // Минимальные цены за 1 взрослого по дням (календарь дат), по направлению плеча
    getTransportPriceCalendar: builder.query({
      query: ({ leg, fromTerminalIds = [], toTerminalIds = [], dateFrom, dateTo }) => {
        const params = new URLSearchParams()

        fromTerminalIds.forEach((id) => params.append("from_terminal_ids[]", id))
        toTerminalIds.forEach((id) => params.append("to_terminal_ids[]", id))
        params.append("date_from", dateFrom)
        params.append("date_to", dateTo)

        return {
          url: `${buildFilterUrl("transport_price_calendar")}?${params.toString()}`,
          method: "GET",
        }
      },
    }),
    getFiltersMeta: builder.query({
      query: () => ({
        url: buildFilterUrl("meta"),
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetTerminalsQuery,
  useGetTerminalsQuery,
  useGetFlightDatesMutation,
  useGetFligthTransportToursMutation,
  useLazyGetTransportPriceCalendarQuery,
  useGetFiltersMetaQuery,
  useLazyGetFiltersMetaQuery,
} = filtersService
